import {
  whiteListAddAddressUrl,
  whiteListChainsUrl,
  whiteListDeleteAddressUrl,
  whiteListGetAddressUrl,
} from "../constant/Api";
import { baseApi } from "./api";

export const whiteListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    addAddress: builder.mutation({
      query: (addressData) => ({
        url: whiteListAddAddressUrl,
        method: "POST",
        body: addressData,
      }),
    }),
    deleteAddress: builder.mutation({
      query: (addressData) => ({
        url: whiteListDeleteAddressUrl,
        method: "DELETE",
        body: addressData,
      }),
    }),
    getAddress: builder.query({
      query: () => ({
        url: whiteListGetAddressUrl,
        method: "GET",
      }),
    }),
    getChains: builder.query({
      query: () => ({
        url: whiteListChainsUrl,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddAddressMutation,
  useDeleteAddressMutation,
  useGetAddressQuery,
  useGetChainsQuery
} = whiteListApi;
